<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Commodity Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button variant="warning" @click="goToMain">New Vendor</b-button>
            </b-nav-form>
          </b-navbar-nav>-->
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-card class="gutr">
              <b-row>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Chapter</label>
                    <b-form-input :formatter="capitalizeAll" id="chapter" name="chapter" v-model="commodityModal.chapter"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!commodityModal.chapter">{{errorList.chapter}}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Item Name</label>
                    <b-form-input :formatter="capitalizeAll" id="itemName" name="itemName" v-model="commodityModal.itemName"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!commodityModal.itemName">{{errorList.itemName}}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>HSN Code</label>
                    <b-form-input :formatter="capitalizeAll" id="hsnCode" name="hsnCode" v-model="commodityModal.hsnCode"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!commodityModal.hsnCode">{{errorList.hsnCode}}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="25">
                    <label for="commodityType">Commodity Type</label>
                    <model-list-select
                      :list="commodityTypeList"
                      v-model="commodityModal.commodityType"
                      option-value="commodityTypeVal"
                      option-text="commodityTypeText"
                      placeholder="Select Commodity Type"
                    ></model-list-select>
                  </md-layout>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <md-layout md-flex="100">
                    <label>Description</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="itemDescription"
                      name="itemDescription"
                      v-model="commodityModal.itemDescription"
                    ></b-form-textarea>
                  </md-layout>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <md-layout md-flex="10" class="justify-content-center mt-3">
                    <b-button
                      variant="primary"
                      @click="addCommodity"
                      id="addButtonLoader"
                    >{{(commodityModal.commodityId!='')?'Update':"Add"}}</b-button>
                    <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                  </md-layout>
                </b-col>
              </b-row>
            </b-card>
            <div class="mt-3">
              <!-- User Interface controls -->
              <b-row>
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>

                      <b-button
                        size="sm"
                        class="ml-2"
                        :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                        @click="getData('Excel')"
                        variant="outline-info"
                        > {{ ExcelBtnName }}
                        <b-spinner
                          v-if="ExcelBtnName != 'Export as Excel'"
                          small
                          label="Small Spinner"
                        ></b-spinner
                      ></b-button>

                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="vehicleSizeMaster"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="commodityId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="itemName" slot-scope="row1">
                    <span @click="editLocation(row1.item)" class="showMoreData">{{row1.item.itemName}}</span>
                  </template>

                  <template slot="isCommodityActive" slot-scope="row2">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row2.item.commodityId">
                      <md-switch
                        :id="'approval' + row2.item.commodityId"
                        name="approval"
                        class="md-primary"
                        :value="row2.item.isCommodityActive == 1 ? true : false"
                        @change="activateUser(row2.item)"
                      >
                        <h6>
                          <br/>
                          <b-badge style="margin-left: -45px">{{
                            row2.item.isCommodityActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row2.item.commodityId">
                      <h6>
                        <b-badge>{{
                          row2.item.isCommodityActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <!-- <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="deleteData(item1.refuelStationId)"
                          >
                            <md-icon>delete_sweep</md-icon>
                  </md-button>-->
                </b-table>
              </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>-->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/location/commodityModal");
      if (globalPermissionStatus("locaionMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("locaionMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }

      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "commodityId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "chapter",
          label: "Chapter",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "hsnCode",
          label: "HSN",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "commodityType",
          label: "Commodity Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "itemDescription",
          label: "Item Description",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isCommodityActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "Hazardous"
        },
        {
          commodityTypeVal: "Non_Hazardous",
          commodityTypeText: "Non Hazardous"
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "Reefer"
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "Others"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      // excelUpload: "",
      commodityModal: {
        commodityId: "",
        chapter: "",
        itemName: "",
        hsnCode: "",
        itemDescription: "",
        commodityType: ""
      },
      CommodityError: [
        "Please Enter Chapter",
        "Please Enter ItemName",
        "Please Enter HSNCode"
      ],
      errorList: {
        chapter: "",
        itemName: "",
        hsnCode: ""
      },

      vehicleSizeMaster: [],
      validate: true,

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")    
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading
  },

  computed: {
    commodityTypeList() {
      return this.commodityTypeName;
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    validateCommodity() {
      let validate_new = true;

      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCommodity.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              // window.location.reload(true);
              if (this.commodityModal.commodityId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }
              this.getData("Normal");

              this.$refs["addPop"].open();
              Object.keys(this.commodityModal).map((x, index) => {
                this.commodityModal[x] = "";
                this.errorList[x] = "";
              });
            }
          })
          .catch(error => {});
      }
    },

    editLocation(item) {
      this.commodityModal.chapter = item.chapter;
      this.commodityModal.itemName = item.itemName;
      this.commodityModal.hsnCode = item.hsnCode;
      this.commodityModal.itemDescription = item.itemDescription;
      this.commodityModal.commodityType = item.commodityType;

      this.commodityModal.commodityId = item.commodityId;
      console.log(this.commodityModal);
    },

    getData(type) {
      let type_Size = {
        commodityModal: "commodityModal",
        Param:'List',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewCommodity.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            this.vehicleSizeMaster = data.CommodityDetails;
            this.totalRows = data.CommodityDetails.length;

            if (type == "Excel") {
              if (data.CommodityDetails.length > 0) {
                this.vehicleSizeMaster = data.CommodityDetails;
                this.totalRows = data.CommodityDetails.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.CommodityDetails.length > 0) {
                this.vehicleSizeMaster = data.CommodityDetails;
                this.totalRows = data.CommodityDetails.length;
                console.log("Vehicle Type Master List response=>", data);
              }
            }

          }
        })
        .catch(error => {});
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.commodityId;

      this.itemObj.isCommodityActive = this.itemObj.isCommodityActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "commoditymaster",
        tableId: "commodityId",
        tableIsActive: "isCommodityActive",
        value1: this.itemObj.isCommodityActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
    
    // downloadExcel() {
    //   let excelName = {
    //     excelName: "LocationMaster",
    //     validExcel: "yes"
    //   };
    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/downloadMasterExcel.php`,
    //     data: JSON.stringify(excelName),
    //     crossDomain: true,
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId")
    //     }
    //   };
    //   axios(options)
    //     .then(result => {
    //       const { statusText, status, data } = result;
    //       if ( status == 200 && data) {
    //         // console.log(data);
    //         // console.log(data.link12);

    //         window.open(data.link12);
    //       }
    //     })
    //     .catch(error => {});
    // },

    // deleteData(id) {
    //   this.deleteId = id;
    //   this.alert.content = "Are you sure you want to delete this item?";
    //   this.$refs["addPop6"].open();
    // },
    // onClose6(type) {
    //   if (type != "cancel") {
    //     let paylod = {
    //       tableName: "frght_portmaster",
    //       tableId: "portId",
    //       tableIsActive: "isPortActive",
    //       tableVal: this.deleteId
    //     };
    //     let options = {
    //       method: "POST",
    //       url: `${URL_BASE}/Api_FFSeaExport/deleteData.php`,
    //       data: JSON.stringify(paylod),
    //       crossDomain: true,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //         Authorization: this.$sessionsStorage.get("loginId")
    //       }
    //     };
    //     axios(options)
    //       .then(result => {
    //         const { statusText, status, data } = result;
    //         if (
    //           data.clientId != "" &&
    //           
    //           status == 200 &&
    //           data
    //         ) {
    //           this.JqueryFun();
    //           this.getData("Normal");

    //           // console.log(data);
    //         }
    //       })
    //       .catch(error => {});
    //   }
    // }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// commodityMaster.vue?10915216